import React from 'react';
import { LogoMark } from '../components/deck/LogoMark';
import { Slide } from '../components/deck/Slide';
import { Eyebrow, Reveal } from '../components/deck/Type';
import { MAP_IMAGE, coverLogos } from '../data/logos';
export function CoverSlide() {
  return <Slide index={1} variant="deep" data-id="element-78" data-mp="g9wx77stgf1g">
      <div className="flex items-end justify-between gap-[3cqw]" data-id="element-79" data-mp="bcoactwq3mtv">
        <div data-id="element-80" data-mp="bbdbn8i4x59m">
          <Eyebrow data-id="element-81" data-mp="3jsq79amdylqv">StartupFuel · DiligenceGPT™</Eyebrow>
          <h1 className="mt-[2.4cqh] max-w-[60cqw] text-[clamp(30px,3.7cqw,80px)] font-normal leading-[1.04] tracking-[-0.015em] text-[#F4F7FC]" style={{
          fontFamily: 'var(--font-serif)'
        }} data-id="element-82" data-mp="3jt9e9wahzpq4">
            Making AI More Accurate, Private &amp; Cost-Efficient for{' '}
            <span className="text-[#3B8CFF]" data-id="element-83" data-mp="3oqrp5s82sf0r">Private Markets</span>
          </h1>
        </div>
        <p className="max-w-[28%] pb-[0.6cqh] text-right text-[clamp(10px,1.1cqw,23px)] leading-snug text-[#AEB7C7]" data-id="element-84" data-mp="310xenhb8b2jo">
          Enterprise-grade AI infrastructure designed to keep proprietary data
          controlled, secure, and out of public model training workflows.
        </p>
      </div>

      <div className="relative mt-[2cqh] flex min-h-0 flex-1 items-center justify-center" data-id="element-85" data-mp="2m1ja1obxhtoo">
        <img src={MAP_IMAGE} alt="World map of startup, venture and innovation ecosystems with connected location nodes" className="max-h-full w-auto max-w-full object-contain opacity-70" style={{
        WebkitMaskImage: 'radial-gradient(ellipse 72% 70% at 50% 50%, #000 62%, transparent 100%)',
        maskImage: 'radial-gradient(ellipse 72% 70% at 50% 50%, #000 62%, transparent 100%)'
      }} data-id="element-86" data-mp="2qv5dcpw7cl7t" />
      </div>

      <Reveal delay={0.15} className="mt-[1.6cqh] flex items-center gap-[3cqw] border-t border-white/10 pt-[2.4cqh]" data-id="element-87" data-mp="2c5pt7sr6fe13">
        <span className="shrink-0 text-[clamp(8px,0.82cqw,17px)] uppercase tracking-[0.26em] text-[#7C8699]" data-id="element-88" data-mp="3nk3agerfcv85">
          Trusted by
        </span>
        <div className="flex flex-1 items-center justify-between" data-id="element-89" data-mp="1oea5hndna7ow">
          {coverLogos.map(logo => <LogoMark key={logo.id} logo={logo} maxW={22} maxH={6} area={60} mono data-id="element-90" data-mp="1jfgx29d7t6vl" />)}
        </div>
      </Reveal>

      <p className="mt-[2cqh] text-[clamp(8px,0.84cqw,17px)] tracking-[0.06em] text-[#6B7588]" data-id="element-91" data-mp="1xdxask9hvxn8">
        DiligenceGPT™ · Investor Presentation · 2026
      </p>
    </Slide>;
}